import React from 'react'
import { Card, Typography, InputNumber, Space } from 'antd'
import { useFFEStore } from '../../../store/ffeStore'
import { SupplierCostingOverview } from './DeliveryCostsPanel'
import TextArea from 'antd/es/input/TextArea'

const { Text } = Typography

interface Props {
  supplierCosting: SupplierCostingOverview
}

export const SupplierCard: React.FC<Props> = ({ supplierCosting }) => {
  const updateSupplierCosts = useFFEStore((state) => state.updateSupplierCosts)

  const handleCostUpdate = (
    field: keyof typeof supplierCosting.costs,
    value: number | string
  ) => {
    updateSupplierCosts(supplierCosting.costs.id, {
      ...supplierCosting.costs,
      [field]: value
    })
  }

  return (
    <Card size="small" title={supplierCosting.name}>
      <div className="space-y-4">
        <div className="text-sm text-gray-500">
          {supplierCosting.items.map((item, index) => (
            <div key={index}>
              {item.code && <Text className="font-mono">{item.code}</Text>}
              {item.code && ' - '}
              {item.name} {item.sku && `(${item.sku})`}
            </div>
          ))}
        </div>

        <Space className="w-full">
          <div className="flex-1">
            <Text type="secondary" className="text-sm block">
              Delivery & Installation
            </Text>
            <InputNumber
              className="w-full"
              value={supplierCosting.costs.deliveryCost}
              onChange={(value) => handleCostUpdate('deliveryCost', value || 0)}
              prefix="$"
              min={0}
            />
          </div>
          <div className="">
            <Text type="secondary" className="text-sm block">
              Margin
            </Text>
            <InputNumber
              className="w-full"
              value={supplierCosting.costs.margin}
              onChange={(value) => handleCostUpdate('margin', value || 0)}
              suffix="%"
              min={0}
            />
          </div>
        </Space>
        <div>
          <Text type="secondary" className="text-sm block">
            Internal Notes
          </Text>
          <TextArea
            value={supplierCosting.costs.notes}
            onChange={(e) => handleCostUpdate('notes', e.target.value)}
            placeholder="Add internal notes about this delivery"
            autoSize={{ minRows: 2 }}
          />
        </div>
      </div>
    </Card>
  )
}
